// extracted by mini-css-extract-plugin
var _1 = "Section-module_section__jrLusA";
var _2 = "Section-module_section_icon__cJdJZJ";
export { _1 as "section", _2 as "section_icon" }
